import { render, staticRenderFns } from "./SaleFilter.vue?vue&type=template&id=00a8131d"
import script from "./SaleFilter.vue?vue&type=script&lang=js"
export * from "./SaleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports